import * as actionType from "./actions/maintenanceDashboardAction";

const initialState = {
  list: [],
  message: "",
  modalOpen: false,
  loading: false,
  apiStatus: false,
};

const maintenanceDashboardReducer = (state = initialState, action) => {
  switch (action?.type) {
    case actionType.API_CALL_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.GET_TPV_CHART_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        TpvChartData: action.payload.tpvChartData,
        TpvTotalCount: action.payload.totalCount,
      };
    case actionType.GET_TPV_MODAL_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        TpvModalData: action.payload.tpvModalData,
      };
    case actionType.GET_INCIDENT_CHART_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        IncidentChartData: action.payload.incidentChartData,
        IncidentTotalCount: action.payload.totalCount,
      };
    case actionType.GET_INCIDENT_MODAL_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        IncidentModalData: action.payload.incidentModalData,
      };
    case actionType.GET_PREVENTIVE_CHART_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        PmpChartData: action.payload.PmpChartData,
        PmpStartDate: action.payload.PmpStartDate,
        PmpEndDate: action.payload.PmpEndDate,
        PmpYtdData: action.payload.PmpYtdData,
      };
    case actionType.GET_PREVENTIVE_MODAL_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        PmpModalData: action.payload.PmpModalData,
      };
    case actionType.GET_WORK_REQUEST_CHART_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        WorkRequestChartData: action.payload.WorkRequestChartData,
        WorkRequestYtdData: action.payload.WorkRequestYtdData,
      };
    case actionType.GET_WORK_REQUEST_MODAL_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        WorkEquestModalData: action.payload.WorkEquestModalData,
      };
    case actionType.STORE_LIST:
      return {
        ...state,
        modalOpen: false,
        message: "",
        StoreList: action.payload.storeList,
      };
    case actionType.INCIDENT_CODE:
      return {
        ...state,
        modalOpen: false,
        message: "",
        IncidentCodes: action.payload.incidentCodes,
      };

    case actionType.PREVENTIVE_MAINTENANCE_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        preventiveMaintenanceData: action.payload.preventiveMaintenanceData,
        pmpYtdTotal: action.payload.pmpYtdTotal,

      };
    case actionType.THIRD_PARTY_AUDIT_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        tpvData: action.payload.tpvData,
      };
    case actionType.MAINTENANCE_INCIDENT_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        incidentBarData: action.payload.incidentBarData,
        incidenDoughnutData: action.payload.incidenDoughnutData,
      };
    case actionType.WORK_REQUEST_DATA:
      return {
        ...state,
        modalOpen: false,
        message: "",
        workRequestData: action.payload.workRequestData,
        requestYdtTotal: action.payload.requestYdtTotal,
      };
    case actionType.ASSET_HEALTH_WEIGHT:
      return {
        ...state,
        weights: action.payload.weights,
      };
    default:
      return state;
  }
};

export default maintenanceDashboardReducer;
